function getAmountMenWomen(diagramData: any) {
    const men = diagramData?.SalariesMen ?? []
    const women = diagramData?.SalariesWomen ?? []

    const totalAmount = men.length + women.length

    if (totalAmount === 0) {
        return { Men: 0, Women: 0 }
    }

    const amountMen = Math.round((men.length / totalAmount) * 100)
    const amountWomen = Math.round((women.length / totalAmount) * 100)

    return { Men: amountMen, Women: amountWomen }
}

export default getAmountMenWomen